export default __webpack_public_path__ + "static/media/numberswarmup_locked_crown.7005830c.svg";